import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // In production, log to monitoring service
    console.error("[Best Agent] Unhandled error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const isDev = process.env.NODE_ENV === "development";
      return (
        <div className="min-h-screen flex items-center justify-center p-8" style={{ background: "#F0F2F5" }}>
          <div className="w-full max-w-lg">
            <div className="bg-white p-10 text-center" style={{ border: "1px solid #E8ECF2", borderRadius: 4, boxShadow: "0 4px 24px rgba(10,25,47,0.07)" }}>
              <div className="w-12 h-12 mx-auto mb-6 flex items-center justify-center" style={{ background: "#FEF2F2", borderRadius: 3 }}>
                <AlertTriangle className="w-6 h-6 text-rose-500" strokeWidth={1.5} />
              </div>
              <h2 className="font-serif text-2xl font-light text-slate-900 mb-2">Qualcosa è andato storto</h2>
              <p className="text-[13px] text-slate-400 mb-8 leading-relaxed">
                Si è verificato un errore inatteso. Il problema è stato registrato automaticamente.
              </p>
              {isDev && this.state.error && (
                <div className="text-left mb-6 p-4 overflow-auto max-h-40" style={{ background: "#FEF2F2", borderRadius: 3, border: "1px solid #FECACA" }}>
                  <p className="text-[11px] font-mono text-rose-700">{this.state.error.toString()}</p>
                </div>
              )}
              <div className="flex items-center justify-center gap-3">
                <button
                  onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                  className="flex items-center gap-2 text-[13px] font-medium px-4 py-2.5 transition-colors"
                  style={{ background: "#0A192F", color: "#fff", borderRadius: 2, border: "none" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#172A45"}
                  onMouseLeave={e => e.currentTarget.style.background = "#0A192F"}
                >
                  <RefreshCw className="w-3.5 h-3.5" strokeWidth={1.8} />
                  Riprova
                </button>
                <button
                  onClick={() => window.location.href = "/"}
                  className="flex items-center gap-2 text-[13px] font-medium px-4 py-2.5 transition-colors"
                  style={{ background: "#fff", color: "#334155", borderRadius: 2, border: "1px solid #E8ECF2" }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = "#CDD1DA"}
                  onMouseLeave={e => e.currentTarget.style.borderColor = "#E8ECF2"}
                >
                  <Home className="w-3.5 h-3.5" strokeWidth={1.8} />
                  Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/* ─── Page-level error boundary (lighter) ─── */
export function PageErrorBoundary({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
